import React, { Component } from 'react';
import {
    Alert,
    Button,
    Col,
    Form,
    FormGroup,
    Input,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader
} from 'reactstrap';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import withErrorHandler from "../../../hoc/withErrorHandler/withErrorHandler";
import axios from "../../../axios-cmk";
import { connect } from "react-redux";
import {
    findPatients,
    hideVisitDetails,
    loadPatient,
    resetPatients,
    saveTherapy,
    setConflictedTerms,
    updateTherapyTerm
} from "../../../store/actions";
import { getPersonById } from "../../../store/helpers";
import { DatePicker, DateTimePicker } from 'react-widgets'
import 'react-virtualized/styles.css'
import 'react-virtualized-select/styles.css'
import './AddTerm.css';
import moment from 'moment'

import VirtualizedSelect from 'react-virtualized-select'
import Spinner from "../../UI/Spinner/Spinner";
import FontAwesome from 'react-fontawesome';


class ConflictTerms extends Component {
    render() {
        const term_list = this.props.terms.map(term => {
            return (
                <div key={term.id}>
                    <div className="conflictDate">{term.date}</div>
                    <div className="conflictHour">[{term.time_start} - {term.time_end}]</div>
                    <div className="conflictPatient">{term.patient ? term.patient.label : "Termin zablokowany"}</div>
                </div>
            )
        });
        const render_result = this.props.terms.length ?
            <Alert color="danger" className="conflictList">
                <h5>Konflikt terminów:</h5>
                {term_list}
            </Alert>
            : '';
        return render_result
    }
}

class ErrorMessage extends Component {
    render() {
        const errorMessage = this.props.message
        return errorMessage ? (
            <Alert color="danger">
                {errorMessage}
            </Alert>
        ) : ''
    }
}

class PersonTermDetails extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedPatient: '',
            selectedHourStart: null,
            selectedHourEnd: null,
            updateFutureTerms: false,
            selectedDate: new Date(),
            selectedVisitDate: new Date(),
            selectedPeriod: this.getSelectedIntervalPeriod(this.props.visit ? this.props.visit.repeat_interval : '604800'),
            selectedTherapist: '',
            loading: false,
            changeTherapyRepeatDate: false,
            term_off_reason: '',
        };
    }

    getSelectedIntervalPeriod(currentValue) {
        return this.props.periods.find(elem => elem.id === currentValue)
    }

    resetStateData = () => {
        this.setState({
            selectedHourStart: null,
            selectedHourEnd: null,
            selectedDate: this.props.selectedBaseDate,
            selectedPeriod: this.getSelectedIntervalPeriod('604800'),
            selectedTherapist: '',
            selectedPatient: '',
            changeTherapyRepeatDate: false,
            updateFutureTerms: false,
            term_off_reason: '',
        });
        this.props.resetPatients()
    };

    handleHourChangeStart = (selectedOption) => {
        this.setState({ selectedHourStart: selectedOption });
    };
    handleHourChangeEnd = (selectedOption) => {
        this.setState({ selectedHourEnd: selectedOption });
    };
    handleDayOffChange = (selectedOption) => {
        this.setState({ term_off_reason: selectedOption });
    };

    componentWillMount() {
        this.timeoutId = 0;
        if (this.props.conflicted_terms.length > 0 || this.props.response_error_message !== '') {
            this.setState({ 'loading': false })
        }
    }

    handlePatientChange = (value) => {
        this.setState({
            selectedPatient: value
        })
    };

    handlePeriodChange = (value) => {
        this.setState({
            selectedPeriod: value
        })
    };

    handlePatientInputChange = (value) => {
        if (value) {
            clearTimeout(this.timeoutId);
            this.timeoutId = setTimeout(() => {
                this.props.findPatients(value);
            }, 150);
        }
    };

    handleDateChange = (value) => {
        this.setState({
            selectedDate: value
        })
    };

    handleFutureTermsChange = () => {
        this.setState({
            updateFutureTerms: !this.state.updateFutureTerms
        })
    };

    handleVisitDateChange = (value) => {
        this.setState({
            selectedVisitDate: value
        })
    };

    toggleEditDate = () => {
        this.setState({
            changeTherapyRepeatDate: !this.state.changeTherapyRepeatDate
        })
    };

    onOpened = () => {
        this.props.setConflictedTerms([]);
        this.setState({ loading: false })
        if (this.props.visit) {
            const visit = this.props.visit
            if (visit.patient) {
                this.props.loadPatient(visit.patient.id)
            }
            this.setState({
                selectedHourStart: moment(this.props.visit.start).toDate(),
                selectedHourEnd: moment(this.props.visit.end).toDate(),
                selectedPatient: visit.patient,
                updateFutureTerms: false,
                selectedTherapist: visit.get_therapist(),
                selectedVisitDate: moment(visit.date).toDate(),
                changeTherapyRepeatDate: false,
                selectedDate: moment(visit.therapy.repeat_end).toDate(),
                term_off_reason: '',
            })

        } else {
            this.resetStateData()
            const start_hour = moment().set({
                hour: this.props.selected_cell.get_hour().key,
                minute: 0,
                second: 0,
                millisecond: 0
            }).toDate()
            this.setState({
                updateFutureTerms: false,
                selectedHourStart: start_hour,
                selectedHourEnd: moment(start_hour).add({ hour: 1 }).toDate(),
                selectedTherapist: this.props.edit_mode ? this.props.selected_cell.get_therapist() :
                    this.props.visit ? getPersonById(this.props.visit.therapist.id) : null,
            })
        }
    }

    handleSaveTherapy = (value) => {
        this.props.setConflictedTerms([])
        this.setState({ 'loading': true })

        let therapyData = {
            patient: this.state.selectedPatient ? this.state.selectedPatient.id : '',
            therapist: this.state.selectedTherapist.id,
            hour_start: moment(this.state.selectedHourStart).format('HH:mm'),
            hour_end: moment(this.state.selectedHourEnd).format('HH:mm'),
            change_later_terms: this.state.updateFutureTerms
        };
        if (this.state.term_off_reason) {
            therapyData = {
                ...therapyData,
                status: this.state.term_off_reason.key
            }
        }
        if (this.props.visit && this.props.visit.id > 0) {
            therapyData = {
                ...therapyData,
                date: moment(this.state.selectedVisitDate).format('Y-MM-DD'),
            }
            if (this.state.changeTherapyRepeatDate) {
                therapyData = {
                    ...therapyData,
                    repeat_end: moment(this.state.selectedDate).format('Y-MM-DD'),
                }
            }
            this.props.updateTherapyTerm(this.props.visit.id, therapyData)
        } else {
            therapyData = {
                ...therapyData,
                name: this.state.selectedPatient.label,
                repeat_start: moment(this.props.selectedBaseDate).format('Y-MM-DD'),
                repeat_end: moment(this.state.selectedDate).format('Y-MM-DD'),
                repeat_interval: parseInt(this.state.selectedPeriod.id, 10),
            };
            this.props.saveTherapy(therapyData);
        }
    }

    render() {
        const person_name = this.state.selectedTherapist ? this.state.selectedTherapist.label : 'UNDEFINED'
        const repeat_interval = this.props.visit ? "" : (
            <div>
                <FormGroup row>
                    <Label for="periodSelect" sm={3}> Powtarzaj </Label>
                    <Col sm={9}>
                        <Select
                            name="periodSelect"
                            value={this.state.selectedPeriod}
                            options={this.props.periods}
                            placeholder="Wybierz okres"
                            onChange={this.handlePeriodChange}
                        />
                    </Col>
                </FormGroup>
            </div>
        );
        const visit_date = this.props.visit ? (<FormGroup row>
            <Label for="patientSelect" sm={3}>Data wizyty</Label>
            <Col sm={9}>
                <DatePicker
                    type="date"
                    name="dateSelect" id="dateVisitSelect"
                    value={this.state.selectedVisitDate}
                    time={false}
                    editFormat='L'
                    format='LL'
                    placeholder="wybierz datę wizyty"
                    required={true}
                    onChange={this.handleVisitDateChange}
                />
            </Col>
        </FormGroup>) : ""

        const repeatDateEndWidget = <DatePicker
            type="date"
            name="dateSelect" id="dateSelect"
            value={this.state.selectedDate}
            time={false}
            editFormat='L'
            format='LL'
            placeholder="wybierz datę zakończenia"
            required={true}
            onChange={this.handleDateChange}
        />

        const dateWidget = this.props.visit ? this.state.changeTherapyRepeatDate ? repeatDateEndWidget : (
            <div className="repeatDateReadOnly" onClick={this.toggleEditDate}>
                {moment(this.props.visit.therapy.repeat_end).format('D MMMM YYYY')}
                <FontAwesome name='edit' />
            </div>) : ""

        const therapy_repeat_date = this.props.visit ? (
            <FormGroup row>
                <Label for="dateSelect" sm={3}>Koniec terapii</Label>
                <Col sm={9}>
                    {dateWidget}
                </Col>
            </FormGroup>
        ) : (
            <FormGroup row>
                <Label for="dateSelect" sm={3}>Koniec terapii</Label>
                <Col sm={9}>
                    {repeatDateEndWidget}
                </Col>
            </FormGroup>
        )

        const future_terms_select = this.props.visit ? (
            <FormGroup row>
                <Label for="hourSelect" sm={11}>Zastosuj godziny do przyszłych terminów</Label>
                <Col sm={1}>
                    <Input
                        type="checkbox"
                        name="update-future-terms"
                        value={this.state.updateFutureTerms}
                        onChange={this.handleFutureTermsChange}
                    />
                </Col>
            </FormGroup>
        ) : '';

        const term_unavailable = this.props.visit && this.props.visit.patient ? '' : (
            <div>
                <hr />
                <FormGroup row>
                    <Label for="termOffSelect" sm={3}>Termin niedostępny</Label>
                    <Col sm={9}>
                        <Select
                            placeholder="Wybierz rodzaj nieobecności"
                            name="form-field-name"
                            value={this.state.term_off_reason}
                            onChange={this.handleDayOffChange}
                            options={this.props.term_off_reasons}
                        />
                    </Col>
                </FormGroup>
            </div>
        )

        const minTimeValue = moment(this.props.selectedBaseDate).set({
            hour: 7,
            minute: 0,
            second: 0,
            millisecond: 0
        }).toDate()
        const maxTimeValue = moment(this.props.selectedBaseDate).set({
            hour: 20,
            minute: 45,
            second: 0,
            millisecond: 0
        }).toDate()
        let form = (
            <Form>
                <FormGroup row>
                    <Label for="hourSelect" sm={3}>Godzina</Label>
                    <Col sm={4}>
                        <DateTimePicker
                            timeFormat="HH:mm"
                            onChange={this.handleHourChangeStart}
                            value={this.state.selectedHourStart}
                            date={false}
                            step={15}
                            min={minTimeValue}
                            max={maxTimeValue}
                        />
                    </Col>
                    <Col sm={1}>
                        -
                    </Col>
                    <Col sm={4}>
                        <DateTimePicker
                            timeFormat="HH:mm"
                            placeholder="Zakończenie"
                            step={15}
                            date={false}
                            value={this.state.selectedHourEnd}
                            onChange={this.handleHourChangeEnd}
                        />
                    </Col>

                </FormGroup>
                {future_terms_select}
                {visit_date}
                <FormGroup row>
                    <Label for="patientSelect" sm={3}>Pacjent</Label>
                    <Col sm={9}>
                        <VirtualizedSelect
                            searchable={true}
                            name="form-field-name"
                            placeholder="Zacznij wpisywać nazwisko pacjenta"
                            noResultsText="Nie znaleziono"
                            value={this.state.selectedPatient}
                            options={this.props.patients}
                            onInputChange={this.handlePatientInputChange}
                            onChange={this.handlePatientChange}
                        />
                    </Col>
                </FormGroup>
                {therapy_repeat_date}
                {repeat_interval}
                {term_unavailable}
            </Form>
        );

        const conflicts = this.props.conflicted_terms ? <ConflictTerms terms={this.props.conflicted_terms} /> : '';

        if (this.state.loading && this.props.conflicted_terms.length === 0) {
            form = <Spinner />
        }
        return (
            <Modal isOpen={this.props.add_new_term_opened} className={this.props.className} onOpened={this.onOpened}>
                <ModalHeader toggle={this.props.hideModal}>
                    {person_name}
                </ModalHeader>
                <ModalBody>
                    <span className="headerDate">
                        {moment(this.props.selectedBaseDate).format('dddd, D MMMM YYYY')}</span>
                    <hr />
                    {form}
                    {conflicts}
                    <ErrorMessage message={this.props.response_error_message} />
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={this.handleSaveTherapy}>Zapisz</Button>{' '}
                    <Button color="secondary" onClick={this.props.hideModal}>Anuluj</Button>
                </ModalFooter>
            </Modal>
        )
    }
}

export const mappings = state => {
    return {
        patients: state.patients.patients,
        therapists: state.cmk.therapists,
        plan_hours: state.cmk.plan_hours,
        periods: state.cmk.periods,
        add_new_term_opened: state.cmk.app_state.add_new_term_opened,
        visit: state.cmk.app_state.current_visit,
        hour: state.cmk.app_state.current_hour,
        selected_cell: state.cmk.app_state.selected_cell,
        edit_mode: state.cmk.app_state.add_new_term_edit_mode,
        selectedBaseDate: state.cmk.selectedBaseDate,
        conflicted_terms: state.cmk.conflicted_terms,
        response_error_message: state.cmk.response_error_message,
        term_off_reasons: state.cmk.term_off_reasons,
    };
}

const mapDispatchToProps = dispatch => {
    return {
        hideModal: () => dispatch(hideVisitDetails()),
        findPatients: (query) => dispatch(findPatients(query)),
        saveTherapy: (newTherapy) => dispatch(saveTherapy(newTherapy)),
        updateTherapyTerm: (id, therapyData) => dispatch(updateTherapyTerm(id, therapyData)),
        loadPatient: (id) => dispatch(loadPatient(id)),
        resetPatients: () => dispatch(resetPatients()),
        setConflictedTerms: (terms) => dispatch(setConflictedTerms(terms))
    }
}

export default connect(mappings, mapDispatchToProps)(withErrorHandler(PersonTermDetails, axios));


// WEBPACK FOOTER //
// ./src/components/Calendar/Terms/AddTerm.js